import DOMPurify from 'dompurify';

/**
 * XSS Sanitization Configuration
 * Allows formatting elements used by Draft.js rich text editor
 * while blocking dangerous scripts and event handlers
 */
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: [
    // Text structure
    'p', 'br', 'div', 'span',
    
    // Headings
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    
    // Lists
    'ul', 'ol', 'li',
    
    // Text formatting
    'b', 'i', 'u', 'strong', 'em', 'strike', 's',
    'sup', 'sub',
    
    // Blocks
    'blockquote', 'pre', 'code',
    
    // Links
    'a',
    
    // Images (for embedded content)
    'img'
  ],
  
  ALLOWED_ATTR: [
    'href', 'target', 'rel',           // For <a> tags
    'src', 'alt', 'width', 'height',   // For <img> tags
    'class', 'style'                   // For styling (Draft.js uses these)
  ],
  
  // Disallow data-* attributes (can be XSS vectors)
  ALLOW_DATA_ATTR: false,
  
  // Only allow safe URL protocols
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  
  // Remove dangerous CSS
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur']
};

/**
 * Sanitize HTML content to prevent XSS attacks
 * @param {string} html - Raw HTML string
 * @returns {string} - Sanitized HTML string safe for dangerouslySetInnerHTML
 */
export const sanitizeHtml = (html) => {
  if (!html || typeof html !== 'string') {
    return '';
  }
  return DOMPurify.sanitize(html, SANITIZE_CONFIG);
};

/**
 * Create props object for dangerouslySetInnerHTML with sanitized content
 * @param {string} html - Raw HTML string
 * @returns {object} - Object ready for spreading: {{ __html: sanitizedContent }}
 */
export const createSanitizedMarkup = (html) => {
  return { __html: sanitizeHtml(html) };
};

export default sanitizeHtml;
